import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container, Icon, Header, Label, Sidebar, Button, Grid, Message, Table, List, Image } from 'semantic-ui-react';
import i18next from 'i18next';

import SideEditor from '../../general/SideEditor';
import { formatPrice } from '../../../helpers/format';
import { exportDataToExcel } from '../../../helpers/excel';
import {
    fetchLoyaltyProgramBenefits,
    fetchLoyaltyProgramRestaurants,
    fetchLoyaltyProgramCampaigns,
    closeIssuedBenefit,
    setEditedEntity
} from '../../../actions';

import IssuesEditor from './IssuesEditor';
import RestaurantThumbnail from '../../../assets/icons/restaurant-icon.svg';
import './Benefits.scss';

class BenefitDetails extends Component {

    state = {
        activeIndex: 0
    };

    constructor(props) {
        super(props);

        this.figureOutIssueState = this.figureOutIssueState.bind(this);
        this.renderIssues = this.renderIssues.bind(this);
        this.renderIssueInfo = this.renderIssueInfo.bind(this);
        this.renderBenefitType = this.renderBenefitType.bind(this);
        this.renderFunding = this.renderFunding.bind(this);
        this.renderValidAt = this.renderValidAt.bind(this);
    }

    componentWillMount() {
        if (this.props.loyaltyProgram && this.props.loyaltyProgram.id) {
            this.props.fetchLoyaltyProgramBenefits(this.props.loyaltyProgram.id);
            this.props.fetchLoyaltyProgramCampaigns(this.props.loyaltyProgram.id);
            if (this.props.loyaltyProgram.restaurantsIds && this.props.loyaltyProgram.restaurantsIds.length) {
                this.props.fetchLoyaltyProgramRestaurants(this.props.loyaltyProgram.id, this.props.loyaltyProgram.restaurantsIds);
            }
        }
    }

    figureOutIssueState(issue) {
        const now = new Date();

        if (!issue.closeDate && issue.expirationDate && now > new Date(issue.expirationDate)) {
            return "expired";
        } else if (!issue.closeDate && (!issue.expirationDate || now < new Date(issue.expirationDate))) {
            return "active";
        }

        return "inactive";
    }

    renderValidAt(validAt) {
        const { restaurants } = this.props;

        if (!validAt || !validAt.restaurants || (Array.isArray(validAt.restaurants) && !validAt.restaurants.length)) {
            return i18next.t("allRestaurants");
        }

        return (
            <List horizontal>
                {restaurants.filter(rest => {
                    return validAt.restaurants.some(restId => restId === rest.id);
                }).map(restaurant => (
                    <List.Item key={restaurant.id}>
                        <Image avatar src={restaurant.thumbnail ? restaurant.thumbnail : RestaurantThumbnail} />
                        <List.Content>
                            <List.Header as='a'>{restaurant.name}</List.Header>
                        </List.Content>
                    </List.Item>
                ))}
            </List>
        );
    }

    renderFunding(loyaltyProgramName, funder) {
        switch (funder) {
            case 'RESTAURANTS':
                return i18next.t("restaurants");
            case 'LOYALTY_PROGRAM':
                return loyaltyProgramName;
            default:
                return 'Paidit';
        }
    }

    renderBenefitType({ financialType, value, categoryId, itemId, currencyCode }) {
        switch (financialType) {
            case 'PERCENT':
                return value + '% ' + i18next.t('discountOnEntireMenu').toLowerCase();
            case 'AMOUNT':
                return formatPrice(value, currencyCode) + ' ' + i18next.t('gift').toLowerCase();
            default:
                return value;
        }
    }

    renderIssueInfo({ campaignId, meta }) {
        const { campaigns } = this.props;
        let { code, members, joinedFrom, firstPayment, minimumAge, maximumAge, paymentTypes } = meta ? meta : {};
        const paymentMethodsDictionary = {
            'american-express': 'American Express',
            'budget': i18next.t('budget'),
            'diners-club': 'Diners Club',
            'isracard': 'Isracard',
            'maestro': 'Maestro',
            'master-card': 'Master Card',
            'visa': 'Visa'
        };

        if (campaignId) {
            var issueCampaign = campaigns.find(camp => camp.id === campaignId);
        }

        return (
            <Label.Group>
                {issueCampaign ? (
                    <Label>
                        {i18next.t('loyaltyProgram.campaign')}
                        <Label.Detail>{issueCampaign.name}</Label.Detail>
                    </Label>
                ) : null}
                {code ? (
                    <Label>
                        {i18next.t('loyaltyProgram.benefitCode')}
                        <Label.Detail>{code}</Label.Detail>
                    </Label>
                ) : null}
                {members ? (
                    <Label>
                        {i18next.t('loyaltyProgram.benefitMembers')}
                        <Label.Detail as='a' onClick={() => exportDataToExcel("members_eligble_for_benefit", "list", [{"phone": 1234}])}>
                            {i18next.t('loyaltyProgram.downloadMembers')}
                        </Label.Detail>
                    </Label>
                ) : null}
                {joinedFrom ? (
                    <Label>
                        {i18next.t('loyaltyProgram.joinedFrom')}
                        <Label.Detail>{new Date(joinedFrom).toLocaleString()}</Label.Detail>
                    </Label>
                ) : null}
                {firstPayment ? (
                    <Label>
                        {i18next.t('loyaltyProgram.firstPayment')}
                        <Label.Detail>{firstPayment ? <Icon name='check' /> : <Icon name='cancel' /> }</Label.Detail>
                    </Label>
                ) : null}
                {minimumAge ? (
                    <Label>
                        {i18next.t('loyaltyProgram.minimumAge')}
                        <Label.Detail>{minimumAge}</Label.Detail>
                    </Label>
                ) : null}
                {maximumAge ? (
                    <Label>
                        {i18next.t('loyaltyProgram.maximumAge')}
                        <Label.Detail>{maximumAge}</Label.Detail>
                    </Label>
                ) : null}
                {paymentTypes ?
                    (<Label.Group color="black">
                        {
                            paymentTypes.map((pt, pti) => (
                                <Label key={pti}>
                                    {'💳'} <Label.Detail>{paymentMethodsDictionary[pt]}</Label.Detail>
                                </Label>
                            ))
                        }
                    </Label.Group>) : null}
            </Label.Group>
        );
    }

    renderIssues(issues) {
        const { loyaltyProgram, benefit, setEditedEntity, closeIssuedBenefit } = this.props;

        return (
            <Table className="pi-issues-details" padded='very' collapsing>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>#</Table.HeaderCell>
                        <Table.HeaderCell>{i18next.t("loyaltyProgram.issueDate")}</Table.HeaderCell>
                        <Table.HeaderCell>{i18next.t("expirationDate")}</Table.HeaderCell>
                        <Table.HeaderCell>{i18next.t("loyaltyProgram.benefitUsage")}</Table.HeaderCell>
                        <Table.HeaderCell>{i18next.t("closeTime")}</Table.HeaderCell>
                        <Table.HeaderCell>{i18next.t("moreInfo")}</Table.HeaderCell>
                        <Table.HeaderCell>{i18next.t("actions")}</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {issues.map((issue, issIndex) => {
                        const issueState = this.figureOutIssueState(issue);

                        return (
                            <Table.Row key={issue.id} positive={issueState === "active"} negative={issueState === "expired"}>
                                <Table.Cell>{issIndex}</Table.Cell>
                                <Table.Cell>
                                    {new Date(issue.issuedAt).toLocaleString()}
                                </Table.Cell>
                                <Table.Cell textAlign='center'>
                                    {
                                        issue.expirationDate ?
                                            new Date(issue.expirationDate).toLocaleString() : '-'
                                    }
                                </Table.Cell>
                                <Table.Cell>
                                    {issue.reusability}
                                </Table.Cell>
                                <Table.Cell textAlign='center'>
                                    {
                                        issue.closeDate ?
                                            new Date(issue.closeDate).toLocaleString() : '-'
                                    }
                                </Table.Cell>
                                <Table.Cell width={6}>
                                    {this.renderIssueInfo(issue)}
                                </Table.Cell>
                                <Table.Cell width={2}>
                                    <Button circular size='tiny' icon='pencil' onClick={() => setEditedEntity('issue', issue)} />
                                    <Button
                                        circular
                                        size='tiny'
                                        icon='calendar times'
                                        negative
                                        onClick={() => closeIssuedBenefit(loyaltyProgram.id, benefit.id, issue.id)}
                                    />
                                </Table.Cell>
                            </Table.Row>
                        );
                    })
                    }
                </Table.Body>
            </Table>

        );
    }

    render() {
        const { loyaltyProgram, benefit, onEdit, setEditedEntity } = this.props;

        if (!loyaltyProgram || !benefit) return null;

        return (
            <div style={{ padding: 10 }}>
                <SideEditor
                    title={i18next.t('loyaltyProgram.issues')}
                    visible={onEdit}
                    handleClose={() => setEditedEntity(null)}
                >
                    <IssuesEditor loyaltyProgramId={loyaltyProgram.id} benefit={benefit} />
                </SideEditor>
                <Container fluid id={benefit.id}>

                    <Message icon attached>
                        <Icon name='gift' />
                        <Message.Content>
                            <Message.Header as='h1' className='pi-benefit-header'>{benefit.description}</Message.Header>

                            <Grid padded className='pi-benefit-details'>
                                <Grid.Row>
                                    <Grid.Column>
                                        <h4 className='pi-benefit-details-category'>{i18next.t('createDate')}: </h4>
                                        {new Date(benefit.createdAt).toLocaleString()}
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column>
                                        <h4 className='pi-benefit-details-category'>{i18next.t('funding')}: </h4>
                                        {this.renderFunding(loyaltyProgram.name, benefit.funder)}
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column>
                                        <h4 className='pi-benefit-details-category'>{i18next.t('loyaltyProgram.validAt')}: </h4>
                                        {this.renderValidAt(benefit.validAt)}
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column>
                                        <h4 className='pi-benefit-details-category'>{i18next.t('loyaltyProgram.benefitType')}: </h4>
                                        {this.renderBenefitType(benefit.type)}
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row><br /></Grid.Row>
                            </Grid>

                        </Message.Content>

                        <Label as='span' color='blue' attached='bottom right'>
                            {benefit.issues.length}
                            <Label.Detail>{i18next.t('loyaltyProgram.issues')}</Label.Detail>
                        </Label>

                    </Message>

                    {
                        Array.isArray(benefit.issues) && benefit.issues.length ?
                            this.renderIssues(benefit.issues) : null
                    }

                    <Message attached='bottom' className='pi-benefit-actions-panel'>
                        <Button.Group className='pi-benefit-actions'>
                            <Button
                                content={i18next.t('loyaltyProgram.addIssue')}
                                icon='add'
                                primary
                                labelPosition='right'
                                onClick={() => setEditedEntity('issue')} />
                        </Button.Group>
                    </Message>

                </Container >
            </div>
        );
    }
}

BenefitDetails.propTypes = {
    fetchLoyaltyProgramBenefits: PropTypes.func,
    fetchLoyaltyProgramCampaigns: PropTypes.func,
    fetchLoyaltyProgramRestaurants: PropTypes.func,
    closeIssuedBenefit: PropTypes.func,
    loyaltyProgram: PropTypes.object,
    benefit: PropTypes.object,
    campaigns: PropTypes.array,
    restaurants: PropTypes.array,
    onEdit: PropTypes.bool,
    setEditedEntity: PropTypes.func,
    
};

function mapStateToProps(state, ownProps) {
    const { benefits, campaigns, restaurants } = state.loyaltyApp;
    const benefit = benefits.find(ben => ben.id === ownProps.match.params.benefitId);
    const onEdit = state.editor.type === 'issue';

    return { benefit, campaigns, restaurants, onEdit };
}
export default connect(mapStateToProps, {
    fetchLoyaltyProgramBenefits,
    fetchLoyaltyProgramRestaurants,
    fetchLoyaltyProgramCampaigns,
    closeIssuedBenefit,
    setEditedEntity
})(BenefitDetails);
